<!--transcript:多科报告 - 校级报告- 成绩单 2024/09/22 17:31:10 YuAng-->

<template>
  <div class="transcript">
    <div class="wrapper">
      <div class="card">
        <div class="header-wrap">
          <div>
            <el-popover placement="right-start" trigger="click">
              <ul class="class-list">
                <li v-for="(item, index) in classList" style="float: left;margin: 0 6px 6px 0;" :key="'schoolClass-'+index">
                  <el-button @click="_chosenClass(item)" :type="item.selected ? 'primary' : 'info'" size="small">{{ item.gradeName }}{{ item.className }}</el-button>
                </li>
              </ul>
              <el-button type="primary" size="small" slot="reference">全部班级</el-button>
            </el-popover>
            <search-bar style="margin-left: 24px;" v-model="keyword" placeholder="搜索(姓名)" @keyup.enter.native="handleCurrentChange()" @search="handleCurrentChange()"></search-bar>
          </div>

          <el-button type="primary" size="small" slot="reference" v-if="isMore !== 2 && isSplit !== 1" @click="showExportPaper">导出原卷</el-button>
        </div>

        <div class="card-table">
          <el-table :data="studentList" border size="medium" max-height="500" @sort-change="handleSortChange" v-loading="pageLoading" style="width: 100%">
            <el-table-column align="center" prop="className" label="班级"></el-table-column>
            <el-table-column align="center" prop="studentNo" sortable label="学号"></el-table-column>
            <el-table-column align="center" prop="studentName" label="姓名"></el-table-column>
            <el-table-column v-for="(sub, index) in subjectList" :label="sub" :key="index" align="center">
              <el-table-column align="center" prop="score" label="得分" :sortable="sub==='总分'">
                <template slot-scope="scope">{{ scope.row.scoreRankVoList[index].score }}</template>
              </el-table-column>
              <el-table-column v-if="showRanking" align="center" prop="classRanking" label="班次" :sortable="sub==='总分'">
                <template slot-scope="scope">{{ scope.row.scoreRankVoList[index].classRanking }}</template>
              </el-table-column>
              <el-table-column v-if="showRanking" align="center" prop="gradeRanking" label="级次" :sortable="sub==='总分'">
                <template slot-scope="scope">{{ scope.row.scoreRankVoList[index].gradeRanking }}</template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <div style="margin-top: 20px;text-align: right;">
            <yue-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :page="pageInfo" :page-sizes="pageSizes"></yue-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 成绩单导出原卷 -->
    <export-paper ref="exportPaper" :examId="examId"> </export-paper>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SearchBar from '@/components/common/SearchBar'
import { reportApi } from '@/v2/utils/api'
import util from '@/v2/utils/util'

export default {
  props: ['gradeId', 'gradeName', 'classList', 'examInfo', 'isMore', 'isSplit'],

  components: {
    SearchBar,
    ExportPaper: () => import('@/pages/exam/components/exportPaper.vue')
  },
  data () {
    return {
      examId: this.$route.params.id,
      keyword: '',
      subjectList: [],
      studentList: [],
      pageLoading: false,
      showRanking: true,
      sortName: '',
      sortType: false,
      pageInfo: {
        current: 1,
        size: 10,
        total: 0
      },
      pageSizes: [10, 20, 30, 50, 100]
    }
  },
  watch: {
    classList (val) {
      if (val) {
        val.map((item) => (item.selected = true))
      }
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo'
    })
  },

  mounted () {
    this._initFunc()
  },

  methods: {
    _initFunc () {
      let params = {
        schoolId: this.userInfo.schoolId,
        subjectCode: this.examInfo.subjectCode,
        isTeacher: true
      }

      reportApi.getShowRanking(params).then(resp => {
        if (resp.success) {
          this.showRanking = resp.body
          this._classMultiReport()
        }
      })
    },
    // 导出原卷
    showExportPaper () {
      this.$refs.exportPaper.setIsShow(true, 'multiple')
    },
    //获取多科班级成绩单
    async _classMultiReport () {
      this.pageLoading = true
      let classIds = this.classList.filter(s => s.selected).map(s => s.id)
      if (classIds.length <= 0) {
        this.pageInfo.current = 1
        this.subjectList = []
        this.studentList = []
        this.pageInfo.total = 0
        this.pageLoading = false
        return
      }

      let params = {
        finalExamId: this.examId,
        orgId: this.userInfo.schoolId,
        classIds: classIds,
        studentName: this.keyword,
        pageSize: this.pageInfo.size,
        currentPage: this.pageInfo.current,
        orderBy: this.sortName,
        isAsc: this.sortType
      }

      let resp = await reportApi.studentRankingByMultiple(params)
      this.pageLoading = false

      if (resp.success && resp.body) {
        if (resp.body.total == 0) {
          this.subjectList = []
          this.studentList = []
          this.pageInfo.total = 0
        }

        let data = resp.body.items
        try {
          const subjectList = []
          const scoreRankVoList = data[0].scoreRankVoList
          if (scoreRankVoList) {
            subjectList.push(
              ...scoreRankVoList.map(item => item.name)
            )
          }

          this.subjectList = subjectList
          this.studentList = data
          this.pageInfo.total = resp.body.totalSize
        } catch (e) {
          console.log(e)
        }
      }
    },
    handleSortChange (column) {
      this.sortName = column.prop
      this.sortType = column.order === 'ascending'
      this._classMultiReport()
    },
    handleCurrentChange (page) {
      this.pageInfo.current = util.isEmpty(page) ? 1 : page
      this._classMultiReport()
    },
    handleSizeChange (val) {
      this.pageInfo.size = val;
      this.handleCurrentChange();
    },
    // 选择班级
    _chosenClass (obj) {
      obj.selected = !obj.selected
      this.handleCurrentChange()
    },

  }
}
</script>

<style lang="scss">
.transcript {
  width: 0;
  flex: 1;
  box-sizing: border-box;
  .wrapper {
    flex: 1;
    box-sizing: border-box;
    margin-top: 14px;
    .card {
      flex: 1;
      border-radius: 4px;
      background: #fff;
      box-shadow: $box-shadow;
      padding-bottom: 10px;
      margin-bottom: 20px;
      .header-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 15px 0;
        > h3 {
          padding: 0 10px;
          height: 40px;
          line-height: 44px;
          font-size: 16px;
          color: $color-text;
          &:before {
            margin-top: -4px;
            display: inline-block;
            content: "";
            width: 4px;
            height: 20px;
            vertical-align: middle;
            background: $color-theme;
            border-radius: 10px;
            margin-right: 10px;
          }
          span {
            padding-left: 20px;
            font-size: $font-size-small;
            color: #aaa;
          }
          .button-group {
            display: inline-block;
            float: right;
          }
        }
      }
    }
    .mistakes-form {
      .el-checkbox-group {
        display: flex;
        justify-content: space-around;
      }
      .el-checkbox {
        width: 33%;
      }
      .el-dialog__body {
        text-align: left;
      }
      .el-dialog__footer {
        text-align: left;
        position: relative;
        .download-btn {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
}

.card-table {
  padding: 10px 15px;
  box-sizing: border-box;
}
</style>
